import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Stack } from '@mui/material';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { useGetCCAssets } from 'src/hooks';

import { AssetsThemeGroup } from '../assetsThemeGroup/AssetsThemeGroup';
import { findUniqueThemes } from './AssetsFlavorGroup.helper';
import type { AssetsFlavorGroupProps } from './AssetsFlavorGroup.interface';
import { CollapseLabel } from './AssetsFlavorGroup.styled';

export const AssetsFlavorGroup = (props: AssetsFlavorGroupProps) => {
  const { data: ccAssets = [] } = useGetCCAssets([
    `id.list=${props.productVariation.asset_id.join('|')}`,
  ]);

  const themes = findUniqueThemes(ccAssets);

  return (
    <Box>
      <Stack alignItems="center" direction="row" justifyContent="space-between">
        <CollapseLabel data-testid="CollapseLabel">{props.label}</CollapseLabel>
        {props.enableUploadProductImages && (
          <IconButton
            component={Link}
            to={`/products/edit/${props.productVariation.group_product_code}`}
            target="_blank">
            <EditIcon />
          </IconButton>
        )}
      </Stack>

      {themes.map((theme) => {
        const assets = ccAssets.filter((asset) =>
          theme.id
            ? asset.theme_id.includes(theme.id)
            : isEmpty(asset.theme_id),
        );

        return (
          !isEmpty(assets) && (
            <AssetsThemeGroup
              key={theme.id}
              productVariationCode={props.productVariation.product_code}
              label={theme.name}
              ccAssets={assets}
              handleAssetChange={props.handleAssetChange}
            />
          )
        );
      })}
    </Box>
  );
};
